import type { User } from "../api/users";
import type { SetupTask } from "./user-setup-progress";
import { getFirstIncompleteTask } from "./user-setup-progress";

export type UserSetupSearch = {
  /** @deprecated Use tab=phone */
  step?: "phone";
  tab?: SetupTask;
  email?: string;
  code?: string;
};

/** Query `code` may be a number when digits-only; always coerce to trimmed string. */
export function normalizeSetupSearchCode(code: unknown): string | undefined {
  if (code == null || code === "") return undefined;
  const normalized = String(code).trim();
  return normalized.length > 0 ? normalized : undefined;
}

export function hasSetupSearchCode(
  search: Pick<UserSetupSearch, "code"> | { code?: unknown },
): boolean {
  return normalizeSetupSearchCode(search.code) !== undefined;
}

const VALID_TABS = new Set<SetupTask>(["email", "phone", "organization"]);

export function parseSetupTab(search: Record<string, unknown>): SetupTask | undefined {
  const tab = search.tab as string | undefined;
  if (tab && VALID_TABS.has(tab as SetupTask)) return tab as SetupTask;
  if (search.step === "phone") return "phone";
  return undefined;
}

/** @deprecated Use getFirstIncompleteTask */
export function getUserSetupInitialStep(
  user: User | null | undefined,
  search: UserSetupSearch,
): number {
  const task = getFirstIncompleteTask(user, search);
  const map: Record<SetupTask, number> = { email: 1, phone: 2, organization: 3 };
  return map[task];
}

export function getUserSetupRedirectSearch(user: User | null | undefined): UserSetupSearch {
  const task = getFirstIncompleteTask(user, {});
  if (task === "phone" || task === "organization") return { tab: task };
  return {};
}
